import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import {Contact, ContactService} from '@app/_components/contact';
import {ContactComponent} from '@app/_components/contact/contact/contact.component';
import {ImportContactComponent} from '@app/_components/contact/import-contact/import-contact.component';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
@Component({
    selector: 'app-property-lead-profile-list',
    templateUrl: './contact-list.component.html',
    styleUrls: ['./contact-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class ContactListComponent implements OnInit {
	constructor(
		private contactService: ContactService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = contactService.statuses;
	}



	// data
	@Input() showFilter = true;
	@Input() showPagination = true;

	contacts: any;
	contact: Contact;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'firstName', header: 'First Name', width: 'auto' },
		{ field: 'lastName', header: 'Last Name', width: 'auto' },
		{ field: 'emailAddress', header: 'emailAddress', width: 'auto' },
		{ field: 'mobilePhone', header: 'mobilePhone', width: 'auto' }
	];

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.contactId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-contact-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.contactService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.contacts = res.data.contacts;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.contacts = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	getFilteredTags(tags) {
		//if filter text input is empty then load all records
		if(tags == '0') {
			delete this.lazyLoadEvent.filters.contactId;
			this.loadLazy(this.lazyLoadEvent);
		} else {
			//If records found then show filtered records
			if(tags.length > 0) {
				//if filter text input is not empty then load filtered records only
				var filteredContactIds = [];
				tags.forEach(tag => {
					filteredContactIds.push(tag.tagSourceId);
				});
				let activityProviderIdFilter = { 'contactId': { 'value': filteredContactIds, 'matchMode': 'in' } };
				Object.assign(this.lazyLoadEvent.filters, activityProviderIdFilter);
				this.loadLazy(this.lazyLoadEvent);
			} else {
				//Display empty table as no record found with filtered input
				this.contacts = [];
			}
		}
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(contact: Contact) {
		try {
			this.formLoading = true;
			this.contactService.update(contact)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.contacts.map((contact, i) => {
							if (contact.contactId === res.data.contact.contactId) {
								this.contacts[i] = res.data.contact;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(contact: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(contact));

			this.formLoading = true;
			this.contactService.delete(contact.contactId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.contacts.splice(this.contacts.indexOf(contact), 1);
						this.recordTotal = this.contacts.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'Contact ' + contact.contactId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'Contact ' + contact.contactId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add Contact'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(ContactComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);
				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				//this.addContactCB(data);
				this.loadLazy(this.lazyLoadEvent);
				// close the dialogBox
				dialogRef.close();
				this.onOpenFormEdit(data as Contact);
			});
	}


	onImportContact() {
		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add Contact'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(ImportContactComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);
				this.loadLazy(this.lazyLoadEvent);
			});
	}

	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(contact: Contact) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			contact: contact,
			title: 'Edit Contact'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(ContactComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				//this.updateContactCB(data);

				this.loadLazy(this.lazyLoadEvent);
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteContactCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addContactCB(contact: Contact) {
		console.log('Adding Contact: ' + JSON.stringify(contact));
		// if we don't have a contacts array yet...
		if (!this.contacts) {
			this.contacts = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.contacts.unshift(contact);

		// no idea what this is but it is required to update the array
		this.contacts = [...this.contacts];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Contact ' + contact.contactId + ' Added', life: 3000 });
	}

	updateContactCB(contact: Contact) {
		console.log('Updating Contact: ' + JSON.stringify(contact));
		let itemIndex = this.contacts.findIndex((item: any) => item.contactId === contact.contactId);
		this.contacts[itemIndex] = contact;

		// no idea what this is but it is required to update the array
		this.contacts = [...this.contacts];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Contact ' + contact.contactId + ' Updated', life: 3000 });
	}

	deleteContactCB(contact: Contact) {
		console.log('Removing Contact: ' + contact);
		this.contacts.splice(this.contacts.indexOf(contact), 1);
		this.recordTotal = this.contacts.length;

		// no idea what this is but it is required to update the array
		this.contacts = [...this.contacts];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Contact ' + contact.contactId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.contacts ? this.first === (this.contacts.length - this.rows) : true; }
	isFirstPage(): boolean { return this.contacts ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(contact: any) {
		if (contact?.status) {
			const status = this.statuses.find((e: any) => e.value == contact.status);
			return status.name;
		}
		else {
			return '';
		}
	}

	reloadPage() {
		window.location.reload();
	}

	showPaginator()
	{
		return true;
	}

  public onExportContacts() {
    try {
      this.loading = true;
      let event = this.lazyLoadEvent;

      if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
        event.multiSortMeta = [];
        event.multiSortMeta.push({ field: 'createDate', order: -1 });
      }

      const pageNumber = Math.round(event.first / event.rows);
      this.contactService.fetchAllContacts(
        pageNumber, event.rows,
        event.sortField,
        event.sortOrder,
        event.multiSortMeta,
        event.globalFilter,
        event.filters).pipe(first()).subscribe(

        (res: any) => {
          this.contacts = res.data.contacts;
          this.exportAsExcelFile(this.contacts, 'myfilecontact');
        },
        (err: any) => {
          console.log('reviews list error!: ' + JSON.stringify(err));
          this.alertService.error(err);
        },
        () => { this.loading = false; }
      );

    } catch (error) {
      this.loading = false;
      console.log('loadLazy(' + event + ')' + error);
    }
  }
  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }
  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }
}
